import { addMessages } from '@hana/i18n';

// Khoá chuỗi của dock Hoá đơn (InvDock.tsx). Dữ liệu mẫu (việc, mail, phiếu duyệt), tên khách và mã nghiệp vụ không dịch.
addMessages('vi', {
  'ivd.tab.an': 'Phân tích', 'ivd.tab.task': 'Việc', 'ivd.tab.appr': 'Duyệt',
  'ivd.st.wait': 'Chờ xác nhận', 'ivd.st.toIssue': 'Chờ xuất', 'ivd.st.issued': 'Đã xuất', 'ivd.st.adj': 'Điều chỉnh',
  'ivd.days': '{n} ngày',
  'ivd.month': 'Tháng 10/2026', 'ivd.unit': 'tr ₫',
  'ivd.k.waitInv': 'Chờ xuất HĐ', 'ivd.k.lateIssue': 'Quá hạn xuất', 'ivd.k.issuedM': 'Đã xuất tháng', 'ivd.k.waitConf': 'Chờ xác nhận',
  'ivd.gaugeAria': 'Tiến độ phát hành tháng {p}%: {d} trên {b} debit đã xuất hoá đơn', 'ivd.gauge': 'Tiến độ phát hành tháng', 'ivd.gaugeSub': 'debit đã xuất HĐ',
  'ivd.today': 'Việc debit hôm nay',
  'ivd.w.todo': 'Chờ làm', 'ivd.w.doing': 'Đang làm', 'ivd.w.waitConf': 'Chờ xác nhận', 'ivd.w.doneToday': 'Xong hôm nay', 'ivd.w.recon': 'Cần đối soát',
  'ivd.byStep': 'Debit theo bước', 'ivd.byStepAria': 'Debit theo bước: {v}', 'ivd.debit': 'debit',
  'ivd.lateIssue': 'Quá hạn phát hành', 'ivd.debitN': '{n} debit', 'ivd.lateAria': 'Quá hạn phát hành (tr ₫): {v}', 'ivd.lateItem': '{k} {v}, trễ {d}',
  'ivd.mailBox': 'Hộp mail billing@', 'ivd.mailN': '{n} mail chưa xử lý',
  'ivd.toTask': 'Thành việc', 'ivd.open': 'Mở {dn}', 'ivd.archive': 'Lưu trữ', 'ivd.done': 'Xong: {k}',
  'ivd.replace': 'Thay thế', 'ivd.origInv': '{a} · HĐ gốc {b} (kỳ 09 đã khoá)',
  'ivd.flow': 'Lập: {a} → Duyệt: [ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP',
  'ivd.approve': 'Duyệt', 'ivd.return': 'Trả lại',
});
addMessages('en', {
  'ivd.tab.an': 'Analytics', 'ivd.tab.task': 'Tasks', 'ivd.tab.appr': 'Approvals',
  'ivd.st.wait': 'Awaiting confirmation', 'ivd.st.toIssue': 'To issue', 'ivd.st.issued': 'Issued', 'ivd.st.adj': 'Adjusted',
  'ivd.days': '{n} days',
  'ivd.month': 'October 2026', 'ivd.unit': 'm ₫',
  'ivd.k.waitInv': 'To invoice', 'ivd.k.lateIssue': 'Overdue to issue', 'ivd.k.issuedM': 'Issued this month', 'ivd.k.waitConf': 'Awaiting confirmation',
  'ivd.gaugeAria': 'Monthly issuing progress {p}%: {d} of {b} debits invoiced', 'ivd.gauge': 'Monthly issuing progress', 'ivd.gaugeSub': 'debits invoiced',
  'ivd.today': 'Debit tasks today',
  'ivd.w.todo': 'To do', 'ivd.w.doing': 'In progress', 'ivd.w.waitConf': 'Awaiting confirmation', 'ivd.w.doneToday': 'Done today', 'ivd.w.recon': 'To reconcile',
  'ivd.byStep': 'Debits by step', 'ivd.byStepAria': 'Debits by step: {v}', 'ivd.debit': 'debits',
  'ivd.lateIssue': 'Overdue to issue', 'ivd.debitN': '{n} debits', 'ivd.lateAria': 'Overdue to issue (m ₫): {v}', 'ivd.lateItem': '{k} {v}, late {d}',
  'ivd.mailBox': 'billing@ mailbox', 'ivd.mailN': '{n} unprocessed emails',
  'ivd.toTask': 'Make task', 'ivd.open': 'Open {dn}', 'ivd.archive': 'Archive', 'ivd.done': 'Done: {k}',
  'ivd.replace': 'Replacement', 'ivd.origInv': '{a} · original invoice {b} (period 09 locked)',
  'ivd.flow': 'Prepared: {a} → Approval: [ACC-CA · Chief Accountant] Vacant seat · escalates to BOD-DIR PHILIP',
  'ivd.approve': 'Approve', 'ivd.return': 'Return',
});
